import { render, staticRenderFns } from "./PortFeeApplication.vue?vue&type=template&id=fcd44546&scoped=true"
import script from "./PortFeeApplication.vue?vue&type=script&lang=js"
export * from "./PortFeeApplication.vue?vue&type=script&lang=js"
import style0 from "./PortFeeApplication.vue?vue&type=style&index=0&id=fcd44546&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd44546",
  null
  
)

export default component.exports